export default function(x) {
  return x === null ? NaN : +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-array/src/number.js
// module id = 9th2
// module chunks = 0